export const SCREENSHOT_TYPES = {
  FULLSIZE: 2,
  THUMBNAIL: 4,
}
